import type { FC } from 'react';

import { useTranslation } from 'react-i18next';

import type { SchemaCreditRequestForm } from '../../../schemas/creditRequestForm.schema';
import { IMMOBILIENDARLEHEN, type IMMOBILIENDARLEHEN_TYPE } from '../../../types';
import { formatIban } from '../../utils/formatIban';
import { ApplicantCell } from '../shared/ApplicantCell';
import { HideCell } from '../shared/HideCell';
import { RefinanceCell } from '../shared/RefinanceCell';
import { currencyFormat, dateFormat, numberFormat } from '~/lib/i18n';

type Props = {
    credit: SchemaCreditRequestForm[IMMOBILIENDARLEHEN_TYPE][number];
    index: number;
    toggleRefinance: (index: number) => void;
    toggleHide: (index: number) => void;
    showDetailedView: boolean;
};

export const TableRowContent: FC<Props> = ({ credit, index, showDetailedView, toggleHide, toggleRefinance }) => {
    const { t } = useTranslation();

    return (
        <>
            <ApplicantCell
                applicant={credit.gehoertZuAntragsteller}
                source={credit.source}
                showDetailedView={showDetailedView}
            />
            <td>{t(`EXISTING_LOANS.TYPES.${IMMOBILIENDARLEHEN}`)}</td>
            <td>{credit.glaeubiger ?? '---'}</td>
            <td>{credit.urspruenglicherKreditbetrag ? currencyFormat(credit.urspruenglicherKreditbetrag) : '---'}</td>
            <td>{credit.zinssatz ? `${numberFormat(credit.zinssatz)} %` : '---'}</td>
            <td>{credit.datumErsteZahlung ? dateFormat(credit.datumErsteZahlung) : '---'}</td>
            <td>
                {credit.kreditLaufzeit
                    ? t('VALUES.MONTH_SHORTHAND', { count: credit.kreditLaufzeit })
                    : t('BANK_CREDIT_REQUEST.REFINANCE_PLANNER.INVALID')}
            </td>
            <td>{credit.datumLetzteRate ? dateFormat(credit.datumLetzteRate) : '---'}</td>
            <td>{credit.rateMonatlich ? currencyFormat(credit.rateMonatlich) : '---'}</td>
            <td>{credit.restschuld ? currencyFormat(credit.restschuld) : '---'}</td>
            <td>{credit.iban ? formatIban(credit.iban) : '---'}</td>
            <RefinanceCell
                credit={credit}
                index={index}
                prefix={IMMOBILIENDARLEHEN}
                creditKind={IMMOBILIENDARLEHEN}
                toggleRefinance={toggleRefinance}
                showDetailedView={showDetailedView}
            />
            <HideCell credit={credit} index={index} toggleHide={toggleHide} prefix={IMMOBILIENDARLEHEN} />
        </>
    );
};
